/** Structural shape of a zod issue, so a consumer SPA needs no `zod` dependency of its own. */
export interface ZodIssueLike {
  path: PropertyKey[];
  message: string;
}

/**
 * Flatten a zod error's `issues` into a map keyed by dot-path, such as
 * `address.zip`; the first issue per path wins. For hand-rolled forms that
 * call `schema.safeParse` and render the message under each field.
 */
export function flattenIssues(issues: readonly ZodIssueLike[]): Record<string, string> {
  const out: Record<string, string> = {};
  for (const issue of issues) {
    const key = issue.path.map((p) => String(p)).join(".");
    if (!(key in out)) out[key] = issue.message;
  }
  return out;
}
